













































































// Vue
import { defineComponent, PropType, computed, ref } from '@vue/composition-api'

// components
import { Form, Input, Radio, Button, Icon } from '@/components/general'

// models
import { BondTypeForm } from '@/models/config'

// services
import { BondTypesService } from '@/services/config'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// utils
import { alerts, loading } from '@/utils'

// constants
import { optionsStatus } from '@/constants'

export default defineComponent({
  name: 'BondTypeFormCreateEdit',
  components: {
    Form,
    Input,
    Radio,
    Button,
    Icon
  },
  props: {
    item: {
      type: Object as PropType<BondTypeForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const optionsMassive = [
      {
        text: 'SI',
        value: true
      },
      {
        text: 'NO',
        value: false
      }
    ]
    const lastNameValidated = ref('')
    const lastCodeValidated = ref('')
    const nameIsUnique = ref(true)
    const codeIsUnique = ref(true)
    const working = ref(false)
    const rules = computed(() => ({
      item: {
        name: { required },
        code: { required },
        is_active: { required },
        is_massive: { required }
      }
    }))
    const $v = useVuelidate(rules, { item: props.item })
    const save = async () => {
      if (!$v.value.item.$invalid && !working.value && nameIsUnique.value && codeIsUnique.value) {
        try {
          loading('show')
          if (props.action === 'save') {
            await BondTypesService.create(props.item)
          } else {
            await BondTypesService.update(props.idEdit, props.item)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error('ERROR.! No se pudo completar la operación')
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }

    const validateName = () => {
      if (props.item.name && props.item.name.trim() !== lastNameValidated.value.trim()) {
        working.value = true
        BondTypesService.getActivated(props.item.name).then(bondTypes => {
          if (bondTypes.length > 0) {
            nameIsUnique.value = false
          } else {
            nameIsUnique.value = true
          }
        }).finally(() => {
          working.value = false
        })
      }
    }
    const validateCode = () => {
      if (props.item.code && props.item.code.trim() !== lastCodeValidated.value.trim()) {
        working.value = true
        BondTypesService.getActivated('', props.item.code).then(bondTypes => {
          if (bondTypes.length > 0) {
            codeIsUnique.value = false
          } else {
            codeIsUnique.value = true
          }
        }).finally(() => {
          working.value = false
        })
      }
    }

    if (props.item.name !== '') {
      lastNameValidated.value = props.item.name
    }

    if (props.item.code !== '') {
      lastCodeValidated.value = props.item.code
    }

    return {
      save,
      optionsStatus,
      nameIsUnique,
      validateName,
      $v,
      validateCode,
      codeIsUnique,
      working,
      optionsMassive
    }
  }
})
